import React, {Component} from 'react';

import {connect} from 'react-redux';
import {FadeLoader} from 'react-spinners';
import moment from 'moment';
import 'rc-tooltip/assets/bootstrap_white.css';
import {
    loadInmatriculacionTitulo,
    postInmatriculacionExcel,
    postInmatriculacionProcesar,
    postInmatriculacionCorreo,
    PAG_0, PAG_1
} from '../actions';

import MainRowSectionCargaTitulo from '../components/Inmatriculacion/MainRowSectionCargaTitulo';


import TablaInmatriculacionCargaTitulo from "./tablasInmatriculacion/tblInmatriculacionCargaTitulo";
import TablaInmatriculacionCargaSituacion from "./tablasInmatriculacion/tblInmatriculacionCargaSituacion";
import TablaInmatriculacionCargaPlaca from "./tablasInmatriculacion/tblInmatriculacionCargaPlaca";
import showModal from "../pages/Inmatriculacion/showModal";

export const CANT_X_PAG_50 = 50;

class InmatriculacionCargaTitulo extends Component {
    CANT_X_PAG_50 = 50;

    static hideMessage() {
        document.getElementById('alert').style.display = 'flex';
        setTimeout(() => {
            if (document.getElementById('alert')) {
                document.getElementById('alert').style.display = 'none';
            }
        }, 5000);
    }

    constructor(props) {
        super(props);
        const modalOpen = '';
        this.state = {
            tipoPlantilla: '1',
            situacionId: '',
            situacionNombre: '',
            selectedID: [],
            countTable: 0,
            dataRows: [],
            closeModal: true,
            cantidadPaginas: 0,
            totalRegistros: 0,
            nroPag: 0,
            nInicio: 0,
            nFin: 0,
            muestraLoad: 'block',
            basedatos: [],
            registros: [],
            errores: [],
            mensajeAlert: '',
            modalOpen
        };

        this.handleOnClickProgramerAll = this.handleOnClickProgramerAll.bind(this);
        this.onClickOptinTab = this.onClickOptinTab.bind(this);
        this.changeTipoPlantilla = this.changeTipoPlantilla.bind(this);
        this.enviarCorreo = this.enviarCorreo.bind(this);
        this.procesarSituacion = this.procesarSituacion.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.handleChangeInicio = this.handleChangeInicio.bind(this);
        this.handleChangeFinal = this.handleChangeFinal.bind(this);

        this.initPaginacion = this.initPaginacion.bind(this);
        this.seleccionar = this.seleccionar.bind(this);

        this.handleClickComboCheck = this.handleClickComboCheck.bind(this);
        this.handleInputChangeComboCheck = this.handleInputChangeComboCheck.bind(this);

        this.changeSearchOption = this.changeSearchOption.bind(this);

        this.selectAll = this.selectAll.bind(this);
        this.changeSearchOptionFechas = this.changeSearchOptionFechas.bind(this);
        this.handleClickComboCheckFiltrar = this.handleClickComboCheckFiltrar.bind(this);
        this.siguiente = this.siguiente.bind(this);
        this.atras = this.atras.bind(this);
        this.clickDescargas = this.clickDescargas.bind(this);
        this.clickDescargarExcel = this.clickDescargarExcel.bind(this);
        this.reiniciarTables = this.reiniciarTables.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickComboCheck, true);
        document.addEventListener('keydown', this.onKeyDown, true);
        this.props.loadInmatriculacionTitulo();
        document.title = 'Divemotor - Inmatriculación - Carga Masiva';
        this.setState({
            muestraLoad: 'none'
        });
        this.handleAllOption();
    }

    seleccionar = value => {
        this.setState({selectRow: value});

        this.setState({errores: InmatriculacionCargaTitulo.joinError(value.error)});
    };
    onClickProcesar = () => {
        const {dataRows} = this.state;

        if (dataRows && dataRows.length === 0) {
            this.setState({
                closeModal: false,
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: 'Seleccione algún registro'
            });
            InmatriculacionCargaTitulo.hideMessage();
            return;
        }

        if (this.state.tipoPlantilla === '3' || this.state.tipoPlantilla === '2') {
            this.openModal("seleccionar-situacion");
            return;
        }

        this.props.postInmatriculacionProcesar({
            'dataExcelList': dataRows,
            'tipoPlantilla': this.state.tipoPlantilla,
            'tipoSituacion': this.state.situacionId,
            'fechaCarga': '',
            'comentario': ''
        }).then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                this.closeModal();
                this.setState({basedatos: [], registros: [], dataRows: []});
                this.setState({
                    closeModal: false,
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#1DB89B',
                    mensajeAlert: 'Se Ejecuto Correctamente'
                });
                this.initPaginacion(0, 0);
                document.getElementById('checkBoxAll').checked = false;
                InmatriculacionCargaTitulo.hideMessage();
            } else {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                });
                InmatriculacionCargaTitulo.hideMessage();
            }
        })
            .catch((error) => {
                document.getElementById('checkBoxAll').checked = false;
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCargaTitulo.hideMessage();
            });
    };

    onClickProcesarV2 = (destinatario, copias, value) => {
        const {dataRows} = this.state;

        if (dataRows && dataRows.length === 0) {
            this.setState({
                closeModal: false,
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: 'Seleccione algún registro'
            });
            InmatriculacionCargaTitulo.hideMessage();
            return;
        }

        if (this.state.tipoPlantilla === '3' || this.state.tipoPlantilla === '2') {
            this.openModal("seleccionar-situacion");
            return;
        }

        this.props.postInmatriculacionProcesar({
            'dataExcelList': dataRows,
            'tipoPlantilla': this.state.tipoPlantilla,
            'tipoSituacion': this.state.situacionId,
            'fechaCarga': '',
            'comentario': ''
        }).then((result) => {

            if (result.payload.data.estadoTrama === '1') {

                this.props.postInmatriculacionCorreo({
                    'items': dataRows,
                    'destinatario': destinatario,
                    'copias': copias,
                    'mensaje': value.mensaje,
                    'enviarXml': value.enviarXml,
                    'enviarPdf': value.enviarPdf
                }).then((result) => {
                    this.setState({selectedID: [], dataRows: []});
                    this.setState({selectRow: null});
                    document.getElementById('checkBoxAll').checked = false;
                    this.closeModal();
                    if (result.payload.data.estadoTrama === '1') {
                        this.setState({
                            muestraLoad: 'none',
                            iconAlert: 'ion-close-circled',
                            colorBackground: '#1DB89B',
                            mensajeAlert: 'Se Ejecuto Correctamente'
                        });
                    } else {
                        this.setState({
                            muestraLoad: 'none',
                            iconAlert: 'ion-close-circled',
                            colorBackground: '#F56669',
                            mensajeAlert: `¡${result.payload.data.mensaje}!`
                        });
                    }
                    var resultList = result.payload.data.resultList;
                    var basedatos = this.state.basedatos;
                    resultList.forEach((itemResult) => {
                        basedatos.forEach((itemBase) => {
                            if (itemBase.numPedidoVeh === itemResult.numPedidoVeh) {
                                itemBase.estado = itemResult.estado;
                                itemBase.error = itemResult.error;
                            }
                        });
                    });
                    basedatos = basedatos.filter(item => (item.estado !== "OK"));
                    this.setState({basedatos: basedatos});
                    this.search(1, 50);
                    InmatriculacionCargaTitulo.hideMessage();

                }).catch((error) => {
                    this.showResultMessage('#F56669','¡Error interno del servidor al enviar correos!');
                });

            } else {
                this.showResultMessage('#F56669','¡${result.payload.data.estadoTrama}!');
            }
        })
            .catch((error) => {
                this.showResultMessage('#F56669','¡Error interno del servidor al procesar !')
            });
    };

    showResultMessage = (color, mensaje) => {
        this.closeModal();
        this.setState({dataRows: [], selectedID: []});
        this.setState({selectRow: null});
        this.setState({
            muestraLoad: 'none',
            iconAlert: 'ion-close-circled',
            colorBackground: color,
            mensajeAlert: mensaje
        });
        this.setState({dataRows: []});
        document.getElementById('checkBoxAll').checked = false;
        InmatriculacionCargaTitulo.hideMessage();
    };

    onClickProcesarItemV2 = (Row, destinatario, copias, value) => {

        if (this.state.tipoPlantilla === '3' || this.state.tipoPlantilla === '2') {
            this.seleccionar(Row);
            this.openModal("seleccionar-situacion");
            return;
        }

        if (Row.fechaTitulo.toString().indexOf('/') === -1) {
            var fecha = new Date(Row.fechaTitulo);
            fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY")
            Row.fechaTitulo = fecha;
        }


        this.props.postInmatriculacionProcesar({
            'dataExcelList': [Row],
            'tipoPlantilla': this.state.tipoPlantilla,
            'tipoSituacion': this.state.situacionId,
            'fechaCarga': '',
            'comentario': ''
        }).then((result) => {
            this.setState({selectRow: null});

            this.props.postInmatriculacionCorreo({
                'items': [Row],
                'destinatario': destinatario,
                'copias': copias,
                'mensaje': value.mensaje,
                'enviarXml': value.enviarXml,
                'enviarPdf': value.enviarPdf
            }).then((result) => {
                if (result.payload.data.estadoTrama === '1') {

                    this.closeModal();
                    this.setState({basedatos: [], registros: [], dataRows: []});
                    this.setState({
                        closeModal: false,
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#1DB89B',
                        mensajeAlert: 'Se Ejecuto Correctamente'
                    });
                    this.initPaginacion(0, 0);
                    document.getElementById('checkBoxAll').checked = false;
                    InmatriculacionCargaTitulo.hideMessage();

                } else {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor: ${result.payload.data.mensaje}!`
                    });
                    InmatriculacionCargaTitulo.hideMessage();
                }
                this.setState({selectRow: null});
            }).catch((error) => {
                this.setState({selectRow: null});
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCargaTitulo.hideMessage();
            });
        })
            .catch((error) => {
                this.setState({selectRow: null});
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCargaTitulo.hideMessage();
            });
    };
    onClickProcesarItem = (Row) => {

        if (this.state.tipoPlantilla === '3' || this.state.tipoPlantilla === '2') {
            this.seleccionar(Row);
            this.openModal("seleccionar-situacion");
            return;
        }

        if (Row.fechaTitulo.toString().indexOf('/') === -1) {
            var fecha = new Date(Row.fechaTitulo);
            fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY")
            Row.fechaTitulo = fecha;
        }


        this.props.postInmatriculacionProcesar({
            'dataExcelList': [Row],
            'tipoPlantilla': this.state.tipoPlantilla,
            'tipoSituacion': this.state.situacionId,
            'fechaCarga': '',
            'comentario': ''
        }).then((result) => {
            this.setState({selectRow: null});
            if (result.payload.data.estadoTrama === '1') {
                this.closeModal();
                this.setState({basedatos: [], registros: [], dataRows: []});
                this.setState({
                    closeModal: false,
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#1DB89B',
                    mensajeAlert: 'Se Ejecuto Correctamente'
                });
                InmatriculacionCargaTitulo.hideMessage();
                this.initPaginacion(0, 0);
            } else {
                this.setState({selectRow: null});
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                });
                InmatriculacionCargaTitulo.hideMessage();
            }
        })
            .catch((error) => {
                this.setState({selectRow: null});
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCargaTitulo.hideMessage();
            });
    };

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickComboCheck, true);
        document.removeEventListener('keydown', this.onKeyDown, true);
    }

    onKeyDown(e) {
        const nameComponente = e.target.getAttribute('name');
        const classComponente = e.target.getAttribute('class');
        if (e.keyCode === 27) {
            document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
        }
        if (e.keyCode === 13) {
            if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
                || (classComponente !== null && (classComponente.indexOf('checkDeGrillaEnterCerrar')>=0))) {
                this.setState({selectedID: [], dataRows: [], closeModal: false, countTable: 0});
                if (document.getElementById('checkBoxAll') !== null) {
                    document.getElementById('checkBoxAll').checked = false;
                }
            }
        }
    }


    /** ********************* */
    setNroPag(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nroPag: PAG_0});
        } else if (this.state.nroPag === 0) { // iniciacion
            this.setState({nroPag: PAG_1});
        }
    }

    setNInicio(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nInicio: PAG_0});
        } else if (this.state.nInicio === 0) { // iniciacion
            this.setState({nInicio: PAG_1});
        }
    }

    setNFin(nuevoTotalRegistros) {
        if (nuevoTotalRegistros < 1) {
            this.setState({nFin: PAG_0});
        } else if (nuevoTotalRegistros === CANT_X_PAG_50) {
            this.setState({nFin: CANT_X_PAG_50});
        } else if (nuevoTotalRegistros < CANT_X_PAG_50) {
            this.setState({nFin: nuevoTotalRegistros});
        } else if (this.state.nFin === 0) { // iniciacion
            this.setState({nFin: CANT_X_PAG_50});
        } else if (this.state.nInicio === 1) {
            this.setState({nFin: CANT_X_PAG_50});
        }
    }


    search(paginaActual, cantidadPorPagina) {
        this.setState({
            registros: this.state.basedatos.filter(function (elem, index, array) {
                var test = ((index + 1) >= (paginaActual - 1) * cantidadPorPagina + 1) && (index < ((paginaActual) * cantidadPorPagina));
                return test;
            })
        });
        this.setState({closeModal: true, selectedID: [], dataRows: []});
        document.getElementById('checkBoxAll').checked = false;
    }

    handleChangeInicio(date) {
        this.setState({startDateInicio: date});
    }

    handleChangeFinal(date) {
        this.setState({startDateFinal: date});
    }

    changeSearchOption(e) {
        this.setState({searchOption: e.target.value, numeroInput: ''});
    }

    changeSearchOptionFechas(e) {
        this.setState({searchOptionFechas: e.target.value});
    }

    handleClickComboCheckFiltrar() {

        this.setState({muestraLoad: 'block', comboSelected: '', closeModal: true});
        this.search(
            PAG_1,
            CANT_X_PAG_50
        );

        document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
    }


    siguiente() {
        let okSiguiente = false;
        let nroPag;
        if (this.state.cantidadPaginas > this.state.nroPag) {
            nroPag = this.state.nroPag + 1;
            okSiguiente = true;
        }
        if (okSiguiente) {

            this.setState({nroPag});
            if ((this.state.nFin + CANT_X_PAG_50) < this.state.totalRegistros) {
                this.setState({nFin: this.state.nFin + CANT_X_PAG_50});
            } else {
                this.setState({nFin: this.state.totalRegistros});
            }
            if (this.state.nInicio < this.state.totalRegistros) {
                this.setState({nInicio: this.state.nInicio + CANT_X_PAG_50});
            }
            this.search(nroPag, CANT_X_PAG_50);
        }

    }

    atras() {
        let okAtras = false;
        let nroPag;
        if (this.state.nroPag > 1) {
            nroPag = this.state.nroPag - 1;
            okAtras = true;
        }
        if (okAtras) {

            this.setState({nroPag});
            if (this.state.nFin === this.state.totalRegistros) {
                this.setState({nFin: this.state.nInicio - 1});
            } else if ((this.state.nFin - CANT_X_PAG_50) < this.state.totalRegistros &&
                (this.state.nFin - CANT_X_PAG_50) !== this.state.totalRegistros) {
                this.setState({nFin: this.state.nFin - CANT_X_PAG_50});
            }
            if (this.state.nInicio <= this.state.totalRegistros) {
                this.setState({nInicio: this.state.nInicio - CANT_X_PAG_50});
            }
            this.search(nroPag, CANT_X_PAG_50);
        }

    }

    selectAll() {
        var selectIds = [];
        var data = [];
        var oficinaRegistral = "";
        if (document.getElementById('checkBoxAll').checked) {
            this.state.basedatos.forEach((item) => {

                if (item.error !== null) {
                    return;
                }

                selectIds.push(item.numPedidoVeh);
                data.push(item);
            });
            this.setState({closeModal: true});
        } else {
            this.setState({closeModal: false});
        }
        this.setState({
            selectedID: selectIds,
            dataRows: data,
            countTable: selectIds.length,
            selectOficinaRegistral: oficinaRegistral
        });
    }


    initPaginacion(totalRegistros, cantidadPaginas) {
        this.setState({
            muestraLoad: 'none',
            totalRegistros: parseInt(totalRegistros, 10),
            cantidadPaginas: parseInt(cantidadPaginas, 10),
        });
        this.setNroPag(totalRegistros);
        this.setNInicio(totalRegistros);
        this.setNFin(totalRegistros);
    }

    handleClickComboCheck(e) {
        const nameComponente = e.target.getAttribute('name');
        const idComponente = e.target.getAttribute('id');
        const classComponente = e.target.getAttribute('class');


        if (nameComponente === 'btnDropdownToggle') {
            if (e.target.parentNode.classList.contains('open')) {
                e.target.parentNode.classList.remove('open');
            } else {
                document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
                e.target.parentNode.classList.add('open');
            }
        } else if (nameComponente === 'iconDropdownToggle') {
            if (e.target.parentNode.parentNode.classList.contains('open')) {
                e.target.parentNode.parentNode.classList.remove('open');
            } else {
                document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
                e.target.parentNode.parentNode.classList.add('open');
            }
        } else {
            document.querySelectorAll('.dropdown.kebab').forEach(dropdown => dropdown.classList.remove('open'));
        }

        if (nameComponente === 'btnDropdownToggle' || nameComponente === 'iconDropdownToggle'
            || (classComponente !== null && (classComponente.indexOf('checkDeGrillaCerrar')>=0))) {
            this.setState({selectedID: [], dataRows: [], closeModal: false, countTable: 0});
            if (document.getElementById('checkBoxAll') !== null) {
                document.getElementById('checkBoxAll').checked = false;
            }
        }

        const combo = document.getElementById(this.state.comboSelected);
        if (this.state.comboSelected) {
            if (combo.contains(e.target) && combo !== e.target) {
                return;
            }
        }
        document.querySelectorAll('.dropdown.dropdown-multi').forEach(dropdown => dropdown.classList.remove('open'));
        if (idComponente === this.state.comboSelected || idComponente === null) {
            this.setState({comboSelected: ''});
        } else if (nameComponente === 'divComboCheck') {
            this.setState({
                comboSelected: idComponente,
            }, e.target.classList.add('open'));
        }
    }

    handleInputChangeComboCheck(event, id, idComponente) {

    }

    seleccionarSituacionItem = (item) => {
        this.setState({situacionId: item.id});
        this.setState({situacionNombre: item.nombre});
        this.setState({modalOpen: ''});
    };


    clickDescargas() {
        if (this.state.muestraDescargas === 'none') {
            this.setState({muestraDescargas: 'block'});
        } else {
            this.setState({muestraDescargas: 'none'});
        }
    }

    clickDescargarExcel() {
        this.setState({});
        this.setState({muestraLoad: 'block', muestraDescargas: 'none'});

    }

    reiniciarTables() {
        this.setState({tipoPlantilla: '1'});

    }

    /** ******************************************************************************************** */




    openModal = modal => this.setState({modalOpen: modal});
    closeModal = () => this.setState({modalOpen: ''});


    changeTipoPlantilla(e) {
        this.setState({tipoPlantilla: e.target.value, registros: [], errores: [], dataRows: [], selectedID: []});
    }


    procesarSituacion(value) {
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });

        var dataEnviar = [];
        if (this.state.selectRow) {
            dataEnviar = [this.state.selectRow];
        } else {
            const {dataRows} = this.state;
            dataEnviar = dataRows;
        }

        this.props.postInmatriculacionProcesar({
            'dataExcelList': dataEnviar,
            'tipoPlantilla': this.state.tipoPlantilla,
            'tipoSituacion': value.situacionId,
            'fechaCarga': value.fechaCarga,
            'comentario': value.comentario,
        }).then((result) => {
            this.closeModal();
            document.getElementById('checkBoxAll').checked = false;
            this.setState({dataRows: [], selectedID: []});
            if (result.payload.data && result.payload.data.estadoTrama === '1') {
                this.setState({basedatos: [], registros: [], dataRows: []});
                this.setState({
                    closeModal: false,
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#1DB89B',
                    mensajeAlert: 'Se Ejecuto Correctamente'
                });
                document.getElementById('checkBoxAll').checked = false;
                this.initPaginacion(0, 0);
                InmatriculacionCargaTitulo.hideMessage();
            } else {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                });
                InmatriculacionCargaTitulo.hideMessage();
            }
        })
            .catch((error) => {
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCargaTitulo.hideMessage();
            });
    }

    enviarCorreo(value) {
        this.setState({
            muestraLoad: 'block',
            closeModal: false,
        });
        var destinatario = [];
        var copias = [];
        value.destinatario && value.destinatario.forEach((item) => {
            destinatario.push(item.text);
        });
        value.copia && value.copia.forEach((item) => {
            copias.push(item.text);
        });

        var dataEnviar = [];
        if (value.item) {
            if (value.item.fechaTitulo.toString().indexOf('/') === -1) {
                var fecha = new Date(value.item.fechaTitulo);
                fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY")
                value.item.fechaTitulo = fecha;
            }
            dataEnviar = [value.item];

        } else {
            const {dataRows} = this.state;
            dataRows.forEach((item) => {
                if (item.fechaTitulo.toString().indexOf('/') === -1) {
                    var fecha = new Date(item.fechaTitulo);
                    fecha = moment(fecha, 'DD/MM/YYYY').format("DD/MM/YYYY")
                    item.fechaTitulo = fecha;
                }
            });
            dataEnviar = dataRows;
        }

        if (value.item) {
            this.onClickProcesarItemV2(value.item, destinatario, copias, value);
        } else {
            this.onClickProcesarV2(destinatario, copias, value);
        }

    }

    handleOnClickProgramerAll = (id, Rows) => {

        if (Rows.error) {
            this.setState({
                muestraLoad: 'none',
                iconAlert: 'ion-close-circled',
                colorBackground: '#F56669',
                mensajeAlert: 'Sólo debe selecionar registros sin errores'
            });
            InmatriculacionCargaTitulo.hideMessage();
            return;
        }


        if (this.state.selectedID.indexOf(id)>=0) {
            this.state.selectedID.splice(this.state.selectedID.indexOf(id), 1);
            this.state.dataRows.splice(this.state.dataRows.indexOf(Rows), 1);
        } else {
            this.setState({
                selectedID: [...this.state.selectedID, id],
                dataRows: [...this.state.dataRows, Rows],
                closeModal: true,
            });
        }
        this.setState({
            countTable: this.state.selectedID.length,
        });

    };

    onClickOptinTab(value, cantidadxPag, nroPag) {
        this.setState({muestraLoad: 'block', selectedID: []});
        if (this.state.estado !== value) {
            this.setState({estado: value});
        }
        this.search(PAG_1, CANT_X_PAG_50);
    }

    onDrop(files) {
        this.setState({
            muestraLoad: 'block',
            basedatos: [],
            dataRows: [],
            selectedID: [],
        });
        files.forEach((file) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("tipoPlantilla", this.state.tipoPlantilla);
            this.props.postInmatriculacionExcel(formData).then((result) => {
                if (result.payload.data.estadoTrama === '1') {
                    this.closeModal();
                    this.setState({basedatos: result.payload.data.resultList});
                    this.setState({
                        muestraLoad: 'none',
                    });
                    this.search(PAG_1, CANT_X_PAG_50);
                    this.initPaginacion(result.payload.data.totalRegistros,
                        result.payload.data.cantidadPaginas);
                } else if (result.payload.data.estadoTrama === '0') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: result.payload.data.mensaje
                    });
                    InmatriculacionCargaTitulo.hideMessage();
                } else if (result.payload.data.estadoTrama === '-1') {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.mensaje}!`
                    });
                    InmatriculacionCargaTitulo.hideMessage();
                } else {
                    this.setState({
                        muestraLoad: 'none',
                        iconAlert: 'ion-close-circled',
                        colorBackground: '#F56669',
                        mensajeAlert: `¡Error interno del servidor:${result.payload.data.estadoTrama}!`
                    });
                    InmatriculacionCargaTitulo.hideMessage();
                }
            }).catch((error) => {
                this.closeModal();
                this.setState({
                    muestraLoad: 'none',
                    iconAlert: 'ion-close-circled',
                    colorBackground: '#F56669',
                    mensajeAlert: '¡Error interno del servidor!'
                });
                InmatriculacionCargaTitulo.hideMessage();
            });
        });
    }


    static joinError(cell) {
        if (cell == null) return [];
        return cell.toString().split("|");

    }


    handleAllOption() {
        if (this.state.closeModal === false) {
            return (<div/>);
        } else if (this.state.selectedID.length > 0)
            if (this.state.tipoPlantilla === '1') {
                return (
                    <div className='alert alert-actions js-open-flex' id='entregaProgramados-tableActions'>
                        <p><span className='bold'>{this.state.selectedID.length} </span><span className='regular'>Elementos seleccionados</span>
                        </p>
                        <button className='btn btn-blue' onClick={() => this.openModal('enviar-correo', this)}>Enviar
                            Correo
                        </button>
                    </div>
                );
            } else if (this.state.tipoPlantilla === '2' || this.state.tipoPlantilla === '3') {
                return (
                    <div className='alert alert-actions js-open-flex' id='entregaProgramados-tableActions'>
                        <p><span className='bold'>{this.state.selectedID.length} </span><span className='regular'>Elementos seleccionados</span>
                        </p>
                        <button className='btn btn-blue' onClick={() => this.onClickProcesar()}>Procesar
                        </button>

                    </div>
                );

            }


    }

    renderTable() {
        if (this.state.tipoPlantilla === '2') {
            return (
                <TablaInmatriculacionCargaPlaca
                    selectedID={this.state.selectedID}
                    openModal={this.openModal}
                    selectAll={this.selectAll}
                    seleccionar={this.seleccionar}
                    onClickProcesarItem={this.onClickProcesarItem}
                    handleOnClickProgramerAll={this.handleOnClickProgramerAll}
                    registros={!this.state.registros ? [] : this.state.registros}
                />);
        } else if (this.state.tipoPlantilla === '3') {
            return (
                <TablaInmatriculacionCargaSituacion
                    selectedID={this.state.selectedID}
                    openModal={this.openModal}
                    seleccionar={this.seleccionar}
                    selectAll={this.selectAll}
                    onClickProcesarItem={this.onClickProcesarItem}
                    handleOnClickProgramerAll={this.handleOnClickProgramerAll}
                    registros={!this.state.registros ? [] : this.state.registros}
                />);
        } else {
            return (
                <TablaInmatriculacionCargaTitulo
                    selectedID={this.state.selectedID}
                    openModal={this.openModal}
                    seleccionar={this.seleccionar}
                    selectAll={this.selectAll}
                    onClickProcesarItem={this.onClickProcesarItem}
                    handleOnClickProgramerAll={this.handleOnClickProgramerAll}
                    registros={!this.state.registros ? [] : this.state.registros}
                />);

        }
    }

    render() {
        return (
            <div>

                <div className='pageHead'>
                    <MainRowSectionCargaTitulo clickDescargarExcel={this.clickDescargarExcel}
                                               clickDescargas={this.clickDescargas}
                                               reiniciarTables={this.reiniciarTables}
                                               openModal={this.openModal}
                                               muestraDescargas={this.state.muestraDescargas}/>

                    <div className='pageHead-rowContainer'>
                        <div className='pageHead-tableConf wrapper'>
                            <h2>
                                <div
                                    className="bold mt--3 open">{this.state.tipoPlantilla === "1" ? "Plantilla Título" : (this.state.tipoPlantilla === "2" ? "Plantilla Placa" : "Plantilla Situaciones")}</div>
                            </h2>
                            <div className='pageHead-tableConf-pagCols'>
                                <nav className='pag'>
                                    <p className='pag-label'>
                                        <span>{this.state.nInicio}</span><span> -</span><span> {this.state.nFin}</span><span> de</span><span> {this.state.totalRegistros}</span>
                                    </p>
                                    <div className='pag-arrows'>
                                        <a className='btn btn-default pag-link checkDeGrillaCerrar' title='Anterior'
                                           onClick={this.atras}><i className='ion-chevron-left'/></a>
                                        <a className='btn btn-default pag-link checkDeGrillaCerrar' title='Siguiente'
                                           onClick={this.siguiente}><i className='ion-chevron-right'/></a>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='wrapper'>
                    <div className='tab-content'>
                        {this.renderTable()}
                    </div>
                </div>

                <div className='modal extraFilter' role='dialog' data-backdrop='static'
                     style={{zIndex: '2000', display: this.state.muestraLoad}}>
                    <div className='modal-dialog modal-sm' role='document'>
                        <FadeLoader color={'#F8A14A'} loading/>
                    </div>
                </div>

                <div className='alert alert-warning' role='alert' id='alert'
                     style={{display: 'none', zIndex: '2000', backgroundColor: this.state.colorBackground}}>
                    <i className={this.state.iconAlert}/>
                    <p>{this.state.mensajeAlert}</p>
                </div>

                {
                    this.handleAllOption()

                }
                {showModal(this.state.modalOpen, this)}

            </div>

        );
    }
}

function mapStateToProps(state) {
    return {registros: state.registros};
}

InmatriculacionCargaTitulo.defaultProps = {
    registros: []
};
export default connect(mapStateToProps, {
    loadInmatriculacionTitulo,
    postInmatriculacionExcel,
    postInmatriculacionProcesar,
    postInmatriculacionCorreo,
})(InmatriculacionCargaTitulo);



// WEBPACK FOOTER //
// ./src/containers/InmatriculacionCargaTitulo.js